export default __webpack_public_path__ + "static/media/NGORealCase2.057772af.jpg";